import * as React from "react";
const SvgDivider = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 4L10 16", stroke: "#EBEBEB", strokeWidth: 2 }));
export default SvgDivider;
